import { object, string } from "yup";
import { defaultContextFields, nonEmptyRequiredString } from "../../shared.js";
const userAccreditation = string()
    .oneOf(["registered-medical-practitioner", "approved-clinician"])
    .default(null)
    .required("Please confirm the correct option");
export const t2Part1DataSchema = object({
    ...defaultContextFields(),
    userAccreditation: userAccreditation,
    treatment: nonEmptyRequiredString.required("Please enter description of treatment or plan of treatment"),
});
export const exampleT2Data = [
    {
        data: {
            user: {
                name: "Clinician",
                email: "david@clinician.com",
                address: "Clinician Address",
                postalCode: "ABC 123",
                isConfirmed: true,
                isSection12Approved: true,
                isGuest: true,
            },
            patient: {
                name: "Patient",
                address: "Patient Address",
                postalCode: "ABC 123",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
            userAccreditation: "registered-medical-practitioner",
            treatment: "REASON",
        },
    },
];
//# sourceMappingURL=t2.js.map